import SelectInput, { TSelectOptions } from '@/components/Select';
import React from 'react';

interface ReceiptExcemptionReasonProps {
  value?: TSelectOptions;
  options: TSelectOptions[];
  onOptionSelected: (option: TSelectOptions, index: number) => void;
}

const ReceiptExcemptionReason: React.FC<ReceiptExcemptionReasonProps> = ({
  value: valueFromParent,
  options,
  onOptionSelected: handleOptionSelect
}) => {
  return (
    <div className="w-full bg-emerge-base-3 rounded-lg p-5 flex justify-between items-center">
      <span className="text-emerge-navy font-medium text-sm">No attachments</span>
      <SelectInput
        className="w-52 h-9 rounded-lg bg-white p-2"
        optionsContainerClass="w-full right-0"
        value={valueFromParent?.label ?? 'Provide reason'}
        options={options}
        onOptionSelected={handleOptionSelect}
      />
    </div>
  );
};

export default ReceiptExcemptionReason;
